import React, { useMemo } from "react";
import { Image } from "@wss/image";
import { PageType } from ".";
import { pageTypes } from "~/common/Constants/Constants";
interface PlusEssentialsPhase4AdProps {
  campaignEndDate: string;
  couponCode: string;
  desktopImage: string;
  accountDesktop: string;
  dollarAmountSaved: number;
  link: string;
  mobileBackgroundImage: string;
  mobileBackgroundImageSmall: string;
  name: string;
  tabletImage: string;
  tabletImageSmall: string;
  trackingName: string;
  trackingTier: number;
  pageType: PageType;
}
const PlusEssentialsPhase4Ad = ({
  desktopImage,
  accountDesktop,
  campaignEndDate,
  couponCode,
  dollarAmountSaved,
  link,
  name,
  tabletImage,
  tabletImageSmall,
  mobileBackgroundImage,
  mobileBackgroundImageSmall,
  trackingName,
  trackingTier,
  pageType
}: PlusEssentialsPhase4AdProps) => {
  const isAdTypeSpreads = name === "spreads";
  const isPageTypeHome = pageType === pageTypes.Home;
  const classNameSelector = useMemo(() => {
    let className = "relative z-10 w-full";
    if (isPageTypeHome) {
      className += " sm:w-3/4 ";
      className += isAdTypeSpreads ? "md:w-11/12 lg:w-3/4" : "md:w-3/5";
    }
    return className;
  }, [isAdTypeSpreads, isPageTypeHome]);
  const displayMobileOrTabletSmallImage = useMemo(() => {
    return <>
        <Image className="block xsl:hidden w-full" src={mobileBackgroundImageSmall} alt="" width={355} height={189} />
        <Image className={`hidden xsl:block w-full ${isPageTypeHome ? "xs:hidden" : "md:hidden"}`} src={mobileBackgroundImage} alt="" width={958} height={509} />
        <Image className={`
                    hidden
                    ${isPageTypeHome ? "w-full h-[215px] xs:block md:hidden" : "md:block lg:hidden h-[224px]"}
                    aspect-auto
                    object-cover
                    object-left`} src={tabletImageSmall} alt="" width={178} height={229} />
      </>;
  }, [isPageTypeHome, mobileBackgroundImage, mobileBackgroundImageSmall, tabletImageSmall]);
  const displayAtLeastTabletImage = useMemo(() => {
    return <>
        {isPageTypeHome || !isAdTypeSpreads ? <>
            <Image className={`
                        hidden
                        absolute
                        lg:block
                        xxl:hidden
                        ${isPageTypeHome ? "w-full h-64 md:block xxl:hidden" : "h-full object-left lg:block xxl:hidden"}
                        aspect-auto
                        object-cover
                        object-left`} src={tabletImage} alt="" width={isAdTypeSpreads ? 266 : 239} height={229} />
            <Image className={`absolute
                        z-0
                        hidden
                        aspect-auto
                        object-cover
                        object-left
                        h-full
                        w-full
                        ${isPageTypeHome ? "" : "xxl:block xxxl:hidden max-w-[550px]"}`} src={accountDesktop} alt="" width={397} height={255} />
            <Image className={`absolute
                      z-0
                      hidden
                      aspect-auto
                      object-cover
                      object-left
                      h-full
                      w-full
                      ${isPageTypeHome ? "xxl:block" : "xxxl:block max-w-[550px]"}`} src={desktopImage} alt="" width={isAdTypeSpreads ? 167 : 517} height={isAdTypeSpreads ? 85 : 255} />
          </> : <>
            <Image className="hidden
                        absolute
                        aspect-auto
                        object-cover
                        h-full
                        object-left
                        lg:block
                        xxl:hidden" src={tabletImage} alt="" width={266} height={229} />
            <Image className="absolute
                        z-0
                        hidden
                        aspect-auto
                        object-cover
                        object-left
                        h-full
                        w-full
                        xxl:block
                        xxxl:hidden
                        max-w-[550px]" src={accountDesktop} alt="" width={167} height={85} />
            <Image className="absolute
                        z-0
                        hidden
                        aspect-auto
                        object-cover
                        object-left
                        h-full
                        w-full
                        xxxl:block
                        max-w-[550px]" src={desktopImage} alt="" width={167} height={85} />
          </>}
      </>;
  }, [accountDesktop, desktopImage, isAdTypeSpreads, isPageTypeHome, tabletImage]);
  const displayImage = useMemo(() => {
    return <>
        {displayMobileOrTabletSmallImage}
        {displayAtLeastTabletImage}
      </>;
  }, [displayAtLeastTabletImage, displayMobileOrTabletSmallImage]);
  return <div className="h-fit" data-sentry-component="PlusEssentialsPhase4Ad" data-sentry-source-file="PlusEssentialsPhase4Ad.tsx">
      <a href={link} className={trackingName} id={`${trackingName}-tier${trackingTier}`} data-testid={`${trackingName}-4`}>
        <div className={`mx-auto
                  mt-8
                  mb-2
                  relative
                  overflow-hidden
                  rounded
                  bg-[#06142B]
                  flex
                  flex-col
                  ${isPageTypeHome ? "xs:flex-row" : "md:flex-row"}
                  justify-between`}>
          <div className={classNameSelector}>
            <div className={`
                        ${isPageTypeHome ? "xs:pr-0 md:pr-0 lt:pr-0 pt-6 px-6 pb-0 xs:pb-6 md:p-[28px] lt:p-8" : "p-5 xxs:p-4 md:p-5 xxl:p-7"}`}>
              <div className={`w-full
                        text-center
                        flex
                        flex-col
                        items-center
                        ${isPageTypeHome ? "xs:text-left xs:items-start" : "md:text-left md:items-start"}`}>
                <h3 data-testid={`${trackingName}-4-headline`} className={`block
                          xxs:hidden
                          text-white
                          font-extrabold
                          mb-2
                          mx-0
                          text-wrap
                          max-w-fit
                          ${isPageTypeHome ? "text-[28px] leading-[30px]" : "text-2xl leading-6"}
                          `} style={{
                textShadow: "none"
              }}>
                  <span>You have ${dollarAmountSaved} in FREE </span>
                  <span className="capitalize">{name}</span>
                </h3>
                <h3 data-testid={`${trackingName}-4-headline`} className={`hidden
                          xxs:block
                          text-white
                          font-extrabold
                          mb-2
                          mx-0
                          text-wrap
                          max-w-fit
                          md:leading-9
                          ${isAdTypeSpreads ? "xs:max-w-[250px] md:max-w-[350px] lt:max-w-[601px]" : ""}
                          ${isPageTypeHome ? "text-3xl md:text-4xl lt:text-[42px] leading-[30px] lt:leading-10" : "text-2xl xsl:text-3xl md:text-4xl xxl:text-[42px] leading-6 xsl:leading-[30px] xxl:leading-10"}
                          ${isAdTypeSpreads && !isPageTypeHome && "lt:!max-w-[500px]"}`} style={{
                textShadow: "none"
              }}>
                  {isPageTypeHome || !isAdTypeSpreads ? <>
                      You have ${dollarAmountSaved} in FREE{" "}
                      {isAdTypeSpreads ? "" : <br />}
                    </> : <>You have ${dollarAmountSaved} in FREE&nbsp;</>}
                  <span className="capitalize">{name}</span>
                </h3>
                <p className={`text-white
                            font-normal
                            text-sm
                            leading-5
                            md:text-base
                            md:leading-5
                            lt:text-lg
                            lt:leading-5
                            text-wrap
                            mb-6
                            ${isPageTypeHome ? "" : "max-w-[323px] xl:max-w-[400px]"}`}>
                  {isPageTypeHome ? <>
                      <span className="block xxs:hidden">
                        Save instantly on select brands of {name} with no
                        minimum spend.
                      </span>
                      <span className="hidden xxs:block">
                        Save instantly on select brands of {name} <br />
                        with no minimum spend.
                      </span>
                    </> : <span>
                      Save instantly on select brands of {name}{" "}
                      <br className="hidden xxs:block xs:hidden xl:block" />
                      with no minimum spend.
                    </span>}
                </p>
                <div className="flex flex-col xs:flex-row items-center gap-x-4">
                  <span className={`bg-white
                            hover:bg-gray-200
                            text-[#06142B]
                            font-semibold
                            px-6
                            py-2
                            rounded
                            ${isPageTypeHome ? "text-xs sm:text-sm md:text-base" : "text-base"}
                            max-w-40
                            whitespace-nowrap`}>
                    Use Code: {couponCode}
                  </span>
                  <div className="flex
                            flex-col
                            mt-4
                            text-white
                            items-center
                            justify-center
                            xs:items-start
                            xs:mt-0">
                    <span className="font-bold text-xs md:text-sm md:leading-[15px]">
                      Offer ends {campaignEndDate}
                    </span>
                    <span className="text-xs font-normal leading-[15px]">
                      Limited Time, Single Use Code
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`
                      relative
                      z-10
                      overflow-visible
                      mt-5
                      ${isPageTypeHome ? "sm:w-4/12 md:w-2/5 xs:mt-0" : "flex justify-end md:mt-0 md:w-2/5 md:h-[224px]  xxl:h-[252px] lt:w-1/4 lg:w-2/5 xl:w-3/4"}`}>
            {displayImage}
          </div>
        </div>
      </a>
    </div>;
};
export default PlusEssentialsPhase4Ad;